import ModalRechazoTipos from './RechazoTipos';
import ModalErrorAction from '../main/ModalErrorAction';
import MotivoRechazoService from '../../api/MotivoRechazoService';
import loaderAction from "../common/loader/LoaderAction";


export const ModalRechazoAction = (estado) => {
    return async dispatch => {
        dispatch({ type: ModalRechazoTipos.data.MOSTRAR_RECHAZO, payload: { showRechazo: estado } });
    };
};

export const GuardarRechazoAction = (idMotivosNumber, idEtapa, trackId) => {
    return async dispatch => {
        try {
            dispatch({ type: ModalRechazoTipos.data.REQUEST_RECHAZO, payload: { enEjecucionAPI: true } });
            dispatch(loaderAction(true));
            const responseRechazo = await MotivoRechazoService.enviarMotivo(idMotivosNumber, idEtapa, trackId);
            if(responseRechazo.data && responseRechazo.data.indicadorAbandonoEtapa===true){
                dispatch({ type: ModalRechazoTipos.data.LOAD_POSTS_REQUEST_RECHAZO, payload: { responseApi: responseRechazo.data.indicadorAbandonoEtapa } });
            }else{
                dispatch({ type: ModalRechazoTipos.data.ERROR_API_RECHAZO, payload: { errorApi:true } });
                dispatch({ type: ModalRechazoTipos.data.MOSTRAR_RECHAZO, payload: { showRechazo: false } });
                dispatch(ModalErrorAction(true));
                dispatch(loaderAction(false));
            }
            
        } catch (error) {
            dispatch({ type: ModalRechazoTipos.data.ERROR_API_RECHAZO, payload: { errorApi:true } });
            dispatch({ type: ModalRechazoTipos.data.MOSTRAR_RECHAZO, payload: { showRechazo: false } });
            dispatch(ModalErrorAction(true));
            dispatch(loaderAction(false));
        }
    };
};

export const obtenerMotivosRechazoAction = () => {
    return async dispatch => {
        try {
            dispatch({ type: ModalRechazoTipos.data.REQUEST_RECHAZO, payload: { enEjecucionAPI: true } });
            const motivosRechazo = await MotivoRechazoService.buscarMotivo();
            if(motivosRechazo.data && motivosRechazo.data.motivoRechazo){
                dispatch({ type: ModalRechazoTipos.data.MOTIVOS_DISPONIBLES, payload: { motivosDisponible: motivosRechazo.data.motivoRechazo } });
            }else{
                dispatch({ type: ModalRechazoTipos.data.ERROR_API_RECHAZO, payload: { errorApi:true } });
                dispatch(ModalErrorAction(true));
            }
            
        } catch (error) {
            dispatch({ type: ModalRechazoTipos.data.ERROR_API_RECHAZO, payload: { errorApi:true } });
            dispatch(ModalErrorAction(true));
        }
    };
};